import { AppLanguage, IEnv } from '@tnq/shared/types';

export const environment: IEnv = {
  production: false,
  apiUrl: 'https://api.test.framna-env-tinqe.cloud/open/v1/',
  upsellApiUrl: 'https://api.test.framna-env-tinqe.cloud/upsell/v1/',
  upsellTokenUrl: 'https://api.test.framna-env-tinqe.cloud/oauth2/token',
  upsellClientId: 'a9463fb5060d305d073e53f7c9e8dc32',
  upsellClientSecret:
    '0de8c6063b8e03a35a82aab506334e26e82472a88386fe67c6627673d283316f4cd6612bd5ed8f0bb316ac12934306610858601e44814a074fddada694e1a904',
  upsellRedirectUri: 'https://flows.test.framna-env-tinqe.cloud/upsell/energy',
  commercialUrl: 'https://tinqe-website-env-test-framna-nl.vercel.app/',
  defaultLang: AppLanguage.Dutch,
  robots: {
    index: false,
    follow: false,
    nosnippet: true,
    noarchive: true,
    nocache: true,
    noimageindex: true,
    nositelinkssearchbox: true,
    googleBot: {
      index: false,
      follow: false,
      noimageindex: true,
      nocache: true,
      noarchive: true,
      nosnippet: true,
      nositelinkssearchbox: true,
    },
  },
};
